<template>
    <div id="richTextEditorForm">
        <input :id="id" type="hidden" name="content" :value="document[field.index]" :placeholder="field.name">
        <!-- updated here -->
        <trix-editor :input="id" class="max-w-5xl"></trix-editor>
    </div>
</template>

<script>
import Trix from 'trix'
import 'trix/dist/trix.css'
import ModelService from "../services/ModelService";
import DataService from "../services/DataService";

export default {
    name: 'RichTextEditorVue3',
    props: ["id", 'table', 'field', 'document'],
    data() {
        return {
            trixText: "",
            service: new ModelService(),
            attachmentPath: '/api/v1/attachments.json',
            timerId: null,
            dataService: new DataService(this.table.id)
        };
    },
    mounted() {
        document.addEventListener("trix-change", this.updateRichText)
        document.addEventListener("trix-focus", this.onFocus)
        document.addEventListener("trix-blur", this.onFocusOut)
        document.addEventListener("trix-attachment-add", this.attachmentAdded)
        document.addEventListener("trix-attachment-remove", this.attachmentRemoved)
    },
    beforeUnmount: function() {
        document.removeEventListener("trix-change", this.updateRichText)
        document.removeEventListener("trix-focus", this.onFocus)
        document.removeEventListener("trix-blur", this.onFocusOut)
        document.removeEventListener("trix-attachment-add", this.attachmentAdded)
        document.removeEventListener("trix-attachment-remove", this.attachmentRemoved)
    },
    methods: {
        updateRichText(e) {
            this.document[this.field.index] = document.getElementById(this.id).value;
        },
        onFocus() {
            console.log('starting timer')
            this.timerId = setInterval(this.saveDocument, 5000);
            console.log('timer id: ' + this.timerId)
        },
        onFocusOut() {
            if(this.timerId) {
                console.log('stopping timer')
                clearInterval(this.timerId)
            }

            this.timerId = null
            this.saveDocument()
        },
        saveDocument() {

            if(this.document['id']) {
                this.dataService.save(this.document)
            }
        },
        attachmentAdded(event) {
            if (event.attachment.file) {
                console.log('attachment added')
                console.log(event)
                this.uploadFileAttachment(event.attachment)
            }
        },
        attachmentRemoved(event) {
            console.log('attachment removed')
            console.log(event)
            // try {
            //     let trixAttachment = event.attachment
            //     let attachmentId = trixAttachment.attachment.attributes.values.webase_id
            //     let service = new AttachmentService()
            //     service.remove(attachmentId)
            //     console.log('Attachment removed')
            // }
            // catch(error) {
            //     console.log('Error removing attachment')
            //     console.log(error)
            // }
        },
        uploadFileAttachment(attachment) {
            this.uploadFile(attachment.file, setProgress, setAttributes)

            function setProgress(progress) {
                attachment.setUploadProgress(progress)
            }

            function setAttributes(attributes) {
                attachment.setAttributes(attributes)
            }
        },

        uploadFile(file, progressCallback, successCallback) {
            let formData = this.createFormData(file)
            let xhr = new XMLHttpRequest()
            xhr.open("POST", this.attachmentPath, true)
            // xhr.setRequestHeader("X-CSRF-Token", Rails.csrfToken())
            xhr.setRequestHeader("x-api-token", webase.model.auth_token)

            xhr.upload.addEventListener("progress", function (event) {
                let progress = event.loaded / event.total * 100
                progressCallback(progress)
            })

            xhr.addEventListener("load", function (event) {
                if (xhr.status == 201) {
                    let response = JSON.parse(xhr.responseText);
                    console.log('Attachment created')
                    console.log(response)

                    let attributes = {
                        url: response.url,
                        href: response.url,
                        webase_id: response.id
                    }
                    successCallback(attributes)
                }
            })

            xhr.send(formData)
        },

        createFormData(file) {
            let data = new FormData()
            data.append("attachment[name]", file.name)
            data.append("attachment[file_type]", file.type)
            data.append("attachment[app_id]", this.table.app_id)
            data.append("attachment[field_id]", this.field.index)
            data.append("attachment[file]", file)
            data.append("Content-Type", file.type)
            return data
        }
    },
};
</script>